import React from "react";
import DraftTopicsList from "./DraftTopicsList";

export default function DraftTopicsPage() {
  return (
    <div className="container mx-auto px-4 flex flex-col flex-grow">
      <div className="mt-3 pb-3 mb-3 border-b border-gray-200">
        <h2>Draft Topics</h2>
      </div>
      <DraftTopicsList />
    </div>
  );
}
